import React from 'react';
import ReactDOM from 'react-dom';
import {
    SubnavigationButton,
    Chip,
    Div,
    FormItem,
    SimpleCell,
    PanelHeaderButton,
    PanelHeader,
    Input,
    SplitLayout,
    SplitCol,
    List,
    RichCell,
    Button, Cell, Spinner
} from '@vkontakte/vkui';
import axios from "axios";
import * as constants from "../assets/constants";
import {Icon12CheckCircle, Icon16ArrowshapeRightOutline, Icon20ScissorsOutline, Icon24Cancel} from "@vkontakte/icons";
import CartApi from "../api/CartApi";
import cartApi from "../api/CartApi";
class Reserves  extends React.Component {
    state = {
        items:[],
        loading: true
    }
    constructor(props) {
        super(props);

    }
    componentDidMount() {
        this.getItems()
    }




    getItems = () => {
        var body = new FormData()
        body.append('product_id', this.props.product.id)
        body.append('sclad_id', this.props.sclad.sclad_id)
        let sAjaxSource = '/?app=partnersproducts&act=getReserves';

        this.setState({
            items: [], loading: true
        });
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true
            }
        ).then((response) => {

            this.setState({loading: false, items: response.data.results})


        })

    }

    render() {
        return (
            <Div>

                <SplitLayout style={{marginBottom:"50px"}}>

                    <SplitCol>
                        {this.state.loading ? <Cell after="Получаем список резервов с сервера"><Spinner size='large'></Spinner></Cell> : this.state.items.map((item, index) => (
                            <SplitLayout style={{fontSize:constants.AdaptivityContext.isMobile?'11px':'inherit'}}  >
                                <SplitCol className="bordered bordered-reserves" style={{whiteSpace:'nowrap'}}  >
                                    <FormItem  >
                                        <div>{item.nomer}</div>
                                        {item.date}
                                    </FormItem>
                                </SplitCol>
                                <SplitCol className="bordered bordered-reserves">
                                    <FormItem  >
                                        {item.username.replace('_', ' ')}
                                    </FormItem>
                                </SplitCol>
                                <SplitCol  className="bordered bordered-reserves" >
                                    <FormItem>
                                        {(item.ost_qnt * this.props.product.unit.K / this.props.current_unit.K).toFixed(3).toString().replace('.000', '')}
                                        <b>{this.props.current_unit.title}</b><br/>
                                        <b>{item.code??''}</b>
                                    </FormItem>
                                </SplitCol>
                            </SplitLayout>))}
                    </SplitCol>

                </SplitLayout>
            </Div>
        )
    }

    formatQnt = (number) => {
        let result = number;

        result = (result * 1).toFixed(3).replace('.000', '')
        if(number.toString().indexOf('.') != -1) {
            while(result.endsWith('0')){
                result = result.substring(0, result.length -1)
            }
        }
        return result;
    }
}

export default Reserves